






























import Vue, { PropType } from "vue";
import Day from "../../domain/Day";

export default Vue.extend( {
  name       : 'DayWithPrice',
  props      : {
    day    : {
      type     : Object as PropType<Day>,
      required : true
    },
    dayKey : {
      type     : Number,
      required : true
    }
  },
  computed   : {
    backgroundBefore() {
      const { colors = {}, hoverColors = {}, hoverToolTip, isHoverActive } = this.day;
      return (
          colors.background_left
          ?? (hoverToolTip && isHoverActive ? hoverColors.background_left : null)
          ?? null
      );
    },
    backgroundAfter() {
      const { colors = {}, hoverColors = {}, isHoverActive, isLastItemHoverActive } = this.day;
      return (
          colors.background_right
          ?? (isHoverActive && !isLastItemHoverActive ? hoverColors.background_right : null)
          ?? null
      );
    },
  },
  components : {
    ToolTip : () => import('./../ToolTip.vue')
  }
} );
